import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PinDateIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M7 1C6.448 1 6 1.448 6 2V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H18V2C18 1.448 17.552 1 17 1C16.448 1 16 1.448 16 2V3H8V2C8 1.448 7.552 1 7 1ZM5 8H19V19H5V8ZM14 13C13.448 13 13 13.448 13 14V16C13 16.552 13.448 17 14 17H16C16.552 17 17 16.552 17 16V14C17 13.448 16.552 13 16 13H14Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PinDateIcon.propTypes = {
  sx: PropTypes.object,
};

export default PinDateIcon;
